import React from "react";
import { Footer } from "../footer";
import LandingSection from "../../home/NewsletterSection";
import { useCart } from "../../../context/CartContext";
import CartDrawer from "../CartDrawer";

const Layout = ({ children }) => {
  const { isDrawerOpen, closeDrawer } = useCart();
  return (
    <>
      <main className="  ">{children}</main>
      <CartDrawer show={isDrawerOpen} handleClose={closeDrawer} />
      <LandingSection />
    </>
  );
};

export default Layout;
